import { createContext } from 'react';

import { AnalyticsReportingService } from './types/analytics-reporting-service';

export const analyticsServiceContext = createContext<{
  report: AnalyticsReportingService;
  sessionIds: Record<string, string>;
} | null>(null);
